<template>
<div class="card">
  <div class="card-body">
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Card"
}
</script>

<style scoped>
.card .card-body {
  flex: 1 1 auto;
  padding: 1rem 1rem;
}
</style>